import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { ListPageLineChart, ListPageLineItem } from '../list-page-charts/types';

export type PlanStatsLineItem = Required<ListPageLineItem>;

export interface PlanStatsLineChart extends ListPageLineChart {
	total: number;
	previousTotal: number;
	data: PlanStatsLineItem[];
}

export interface PlanStatsResponse {
	line: PlanStatsLineChart;
}

export const useGetPlansStats = (enabled = true) => {
	return useQuery({
		queryKey: ['plans', 'stats'],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PlanStatsResponse>('/management/plan/stats');
			return data;
		},
	});
};
